module.exports = __webpack_public_path__ + "static/media/regular.37f2c5ee.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/regular.woff2
// module id = 48
// module chunks = 0